import React from "react";
import styles from "./index.module.scss";
import icon from "./logo.png";
export default class Logo extends React.Component {
    static defaultProps = {
        className: "",
    };
    render() {
        return (React.createElement("img", { src: icon, alt: "Expense Reduction Analysts", className: `${styles.logo} ${this.props.className}`, onClick: this.props.onClick }));
    }
}
